import { CustomPropInputType } from '../../customprop.type/model/customprop.type';
import { ModuleModel } from '../../module.model.interface';

export class CustomPropValueDescriptor implements ModuleModel {
  public discriminator = 'CustomPropValueDescriptor';

  public id: string;
  public customPropTypeId: string;
  public relatedObjectId: string;
  public value: string;

  public customPropTypeName: string;
  public customPropTypeDescription: string;
  public customPropTypeInputType: CustomPropInputType;
  public customPropTypeArgument: string;

  public href: string;
  public modified: Date;
  public deleted: Date;

  constructor(options?: {
    id: string;
    customPropTypeId: string;
    relatedObjectId: string;
    value: string;

    href: string;
    modified: Date;
    deleted: Date;
  }) {

    if (options) {
      this.id = options.id;
      this.customPropTypeId = options.customPropTypeId;
      this.relatedObjectId = options.relatedObjectId;
      this.value = options.value;

      this.href = options.href;
      this.modified = options.modified;
      this.deleted = options.deleted;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/customprop.value/model/customprop.value.ts